import { Edges } from "@react-three/drei"
import * as THREE from 'three'

export interface IContainer {
    w: number,
    h: number,
    d: number,
}

const Container = ({ size }: { size: IContainer }) => {
    const { w, h, d } = size;

    return (
        <>
            {/* 바닥 */}
            <mesh
                rotation-x={-Math.PI / 2}
                receiveShadow
            >
                {/* 컨테이너 바닥 크기 맞춰서 args 조절 */}
                <planeGeometry args={[w, d]} />
                <meshStandardMaterial color="#ac441f" />
            </mesh>

            {/* 컨테이너 벽 (투명 박스 안쪽면만 보이도록 BackSide) */}
            <mesh
                position={[0, h / 2 + 0.001, 0]}       // 높이 절반만큼 올려서 바닥 위에 뜨게
            >
                {/* 컨테이너 내부 크기: 길이×높이×폭 */}
                <boxGeometry args={[w, h, d]} />
                <meshStandardMaterial
                    color="lightblue"
                    transparent
                    opacity={0.2}
                    side={THREE.BackSide}
                />
                {/* 모서리만 강조 */}
                <Edges
                    scale={1}
                    threshold={15}  /* 각도 임계값 이상인 엣지만 렌더 */
                    color="red"
                />
            </mesh>
        </>
    )
}

export default Container